import "./Community.module.css";
import Header from "@/reusable_sections/Header";
import OurManifesto from "./sections/OurManifesto";
import TheCoreTeam from "./sections/TheCoreTeam";
import HubEvolution from "./sections/HubEvolution";
import Footer from "@/reusable_sections/Footer";
export default function CommunityPage() {
  return <div>
      <Header />
      <OurManifesto />
      <TheCoreTeam />
      <HubEvolution />
      <Footer />
    </div>;
}